import z from "zod";
import {passwordSchema} from "../common/passwordSchema";

const passwordChangeRequestSchema = z.object({
    oldPassword: z.string().min(1, 'Zadejte staré heslo'),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
}).refine(data => data.newPassword === data.confirmPassword, {
    message: 'Hesla se neshodují',
    path: ['confirmPassword'],
});

type PasswordChangeSchema = z.infer<typeof passwordChangeRequestSchema>;

export {passwordChangeRequestSchema, type PasswordChangeSchema};
